import { render, staticRenderFns } from "./commentManage.vue?vue&type=template&id=62e5d919&scoped=true&"
import script from "./commentManage.vue?vue&type=script&lang=js&"
export * from "./commentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e5d919",
  null
  
)

export default component.exports